import { useContext } from 'react';

import { LocalizationContext } from '@hrworks/localization';

import { Button } from '../Button';
import { S } from './ConfirmationModal.styles';
import type { ConfirmationModalProps } from './ConfirmationModal.types';

export const ConfirmationModal = ({
  onConfirm,
  onCancel,
  onReject,
  confirmText,
  cancelText,
  rejectText,
  slots,
  slotProps,
  ...otherProps
}: ConfirmationModalProps) => {
  const { translate } = useContext(LocalizationContext);

  const CancelButton = slots?.cancel || Button;
  const RejectButton = slots?.reject || Button;
  const ConfirmButton = slots?.confirm || Button;

  return (
    <S.ConfirmationModal
      closeable={!!onCancel}
      onClose={onCancel}
      footer={
        <>
          {onCancel && (
            <CancelButton {...(!slots?.cancel && { variant: 'subtle' })} onClick={onCancel} {...slotProps?.cancel}>
              {slotProps?.cancel?.children || cancelText || translate('confirmation-modal-cancel')}
            </CancelButton>
          )}
          {onReject && (
            <RejectButton {...(!slots?.reject && { variant: 'subtle' })} onClick={onReject} {...slotProps?.reject}>
              {slotProps?.reject?.children || rejectText || translate('confirmation-modal-reject')}
            </RejectButton>
          )}
          {onConfirm && (
            <ConfirmButton {...(!slots?.confirm && { variant: 'filled' })} onClick={onConfirm} {...slotProps?.confirm}>
              {slotProps?.confirm?.children || confirmText || translate('confirmation-modal-confirm')}
            </ConfirmButton>
          )}
        </>
      }
      {...otherProps}
    />
  );
};
